import { RootState } from '@/lib/store';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import SidebarItemSection from '../Item/Section';

export default function VipClubSection() {
  const { t } = useTranslation('common');
  const { push } = useRouter();
  const isAdminView = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );

  function handleNavigate() {
    if (isAdminView) {
      return;
    }

    push(`/vip-club`);
  }

  return (
    <SidebarItemSection
      label={t('vip_club_title')}
      icon="fa-solid fa-crown"
      onClick={handleNavigate}
    />
  );
}
